import React, { useContext, useState } from 'react';
import { TabsProps } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import { salesOrdersContainerConfiguration } from '@totem/components/salesOrders/list/containerConfiguration';
import SalesOrdersLayout from '@totem/components/salesOrders/list/SalesOrdersLayout';
import Contacts from '@totem/components/settings/sections/contacts/contacts';
import NozomiEventConfigSection from '@totem/components/settings/sections/nozomi/eventConfiguration/nozomiEventConfigSection';
import Services from '@totem/components/settings/sections/services/Services';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

import SalesOrdersContainer from '../salesOrders/list/SalesOrdersContainer';
import ContentLayout from '../ui_components/page/ContentLayout';

import Account from './sections/account/Account';
import { SettingType } from './constants';

const Settings = () => {
  const { userProfile } = useContext(UserProfileContext);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const settingsTab = params.get('st');
  const [currentKey, setCurrentKey] = useState<any>(
    typeof settingsTab !== 'undefined' && settingsTab !== null
      ? settingsTab
      : SettingType.ACCOUNT,
  );

  const getTabItems = () => {
    const tabItems: TabsProps['items'] = [];

    if (permissions.systemAdministrator.hasPermissions(userProfile)) {
      tabItems.push({
        key: SettingType.ACCOUNT,
        label: 'Account Settings',
        children: <Account />,
      });

      tabItems.push({
        key: 'contacts',
        label: 'Contacts',
        children: <Contacts />,
      });

      tabItems.push({
        key: SettingType.SERVICES,
        label: 'Services',
        children: <Services />,
      });

      tabItems.push({
        key: SettingType.EVENT_CONFIGURATION,
        label: 'Event Configuration',
        children: <NozomiEventConfigSection />,
      });

      if (permissions.contractsViewer.hasPermissions(userProfile)) {
        tabItems.push({
          key: 'salesOrders',
          label: (
            <IBTooltip content={permissions.contractsViewer.tooltip}>
              {'Sales Orders'}
            </IBTooltip>
          ),
          children: (
            <InputContainer
              filterConfig={salesOrdersContainerConfiguration}
              defaultSort={{
                field: 'nsSalesOrder.tranId',
                direction: 'ascend',
              }}
              componentKey={'account.salesOrders'}
            >
              <SalesOrdersContainer>
                <SalesOrdersLayout />
              </SalesOrdersContainer>
            </InputContainer>
          ),
        });
      }
    }

    return tabItems;
  };

  return (
    <ContentLayout>
      <IBCard title={'Account Settings'} isCovered>
        <IBTabs
          activeKey={currentKey}
          onChange={(key) => setCurrentKey(key)}
          items={getTabItems()}
        />
      </IBCard>
    </ContentLayout>
  );
};

export default Settings;
